import * as types from "../constants";
import axios from "../../plugins/axios";

const apiUrl = process.env.REACT_APP_CASENEST_API_URL;

const generateResponse = async (dispatch, caseId, getState) => {

    const { cases } = getState().caseReducer;

    const aiState = cases[caseId].aiState;

    const { conversationId, assistantId, containerId } = aiState;

    let response = await axios.post(`${apiUrl}/aiThread/GenerateResponse`, {
        conversationId,
        promptId: assistantId,
        containerId,
        caseId,
    });        

    console.log({generateResponse: response});

    await getItems(dispatch, caseId, getState);

    dispatch({
        type: types.SET_CASE_AI_STATE,
        caseId,
        payload: {
            processing: false,
            alert: true,
            used: true,
            containerId: response.data.containerId
        }
    });    
};

const getItems = async (dispatch, caseId, getState) => {

    console.log('newfiles');
    const { cases } = getState().caseReducer;

    const aiState = cases[caseId].aiState;

    const { conversationId, files } = aiState;

    const response = await axios.get(`${apiUrl}/aiThread/items/${conversationId}`);

    let items = response.data;    

    let existingFileIds = files.map(f => f.azureFileReference);

    let newFiles = [...files];    

    for (const m of items) {
        for (const f of m.files) {
            if (!existingFileIds.includes(f.azureFileReference)) {
                newFiles.push(f);
            }
        }        
    }

    console.log({items, newFiles});

    dispatch({
        type: types.SET_CASE_AI_STATE,
        caseId,
        payload: {
            messages: items,
            files: newFiles,
        }
    });    
}

const createConversation = async (dispatch, caseId) => {

    var response = await axios.get(`${apiUrl}/aithread/newconversation`);   
    let { conversationId, containerId } = response.data;

    dispatch({
        type: types.SET_CASE_AI_STATE,
        caseId,
        payload: { conversationId, containerId }
    });

    return { conversationId, containerId };
}

export const aiActionCreators = {    
    
    addAIItem: (caseId, currentMessage) => async (dispatch, getState) => {

        const { cases } = getState().caseReducer;

        const aiState = cases[caseId].aiState;

        let { conversationId, containerId } = aiState;

        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: {
                processing: true,
            }
        });

        if (!conversationId) {
            ({ conversationId, containerId } = await createConversation(dispatch, caseId));
        }

        await axios.post(`${apiUrl}/aiThread/addItem`, {
            conversationId,
            containerId,
            caseId,
            text: currentMessage,
        });       

        await getItems(dispatch, caseId, getState);

        await generateResponse(dispatch, caseId, getState);        
    },

    addFile: (caseId, azureReference, filename, contentType, azureFileId) => async (dispatch, getState) => {        

        const { cases } = getState().caseReducer;

        const aiState = cases[caseId].aiState;

        let { conversationId, containerId } = aiState;

        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: {
                processing: true
            }
        });

        if (!conversationId) {
            ({ conversationId, containerId } = await createConversation(dispatch, caseId));
        }

        let response = await axios.post(`${apiUrl}/aiThread/addFile`, {
            conversationId,
            containerId,
            caseId,
            azureReference,
            filename,
            contentType,
            azureFileId,
        });

        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: {
                processing: false,
                containerId: response.data.containerId,
            }
        });

        await getItems(dispatch, caseId, getState);
    },

    checkMessages: (caseId) => async (dispatch, getState) => {        

        await getItems(dispatch, caseId, getState);

    },    

    setAssistantId: (caseId, assistantId) => async (dispatch) => {
        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: { assistantId }
        });
    },


    reset: (caseId) => async (dispatch) => {
        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: { conversationId: null, containerId: null, messages: [] }
        });
    },

    setThumbsUp: (caseId, messageId, thumbsUp) => async (dispatch, getState) => {

        if (!thumbsUp)
            dispatch({
                type: types.SET_SNACK,
                snack: {
                    message: "I'm sorry to hear you weren't satisfied. Please share specific details on what could be improved in my response.",
                    severity: "warning"
                }
            });

        const { cases } = getState().caseReducer;

        const aiState = cases[caseId].aiState;

        const { thumbsUpIds, thumbsDownIds } = aiState;

        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: {
                thumbsUpIds: thumbsUp ? [ ...thumbsUpIds, messageId] : thumbsUpIds.filter(id => id !== messageId),
                thumbsDownIds: !thumbsUp ? [ ...thumbsDownIds, messageId] : thumbsDownIds.filter(id => id !== messageId)
            }
        });

        axios.post(`${apiUrl}/aithread/SetThumbsUp/${messageId}/${thumbsUp}`);
    },

    clearAlert: (caseId) => async (dispatch) => {
        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: {
                alert: false
            }
        });
    },

    setCurrentMessage: (caseId, currentMessage) => async (dispatch) => {
        dispatch({
            type: types.SET_CASE_AI_STATE,
            caseId,
            payload: {
                currentMessage
            }
        });
    }
};

export default aiActionCreators;